import { Sutl } from '../../../../sutl';
import { ValueBridge } from './ValueBridge';
export class CalendarBridge extends ValueBridge {
    constructor(state, control, controlInfo, powerState, transport, valueCallback, log) {
        super('calendar', state, control, controlInfo, powerState, transport, valueCallback, log);
    }
    convertToParam(calendar) {
        const calendarValue = { events: Sutl.arrayToObj(calendar.events, 'a') };
        if (calendar.eventWindowDays)
            calendarValue.eventWindowDays = calendar.eventWindowDays;
        return calendarValue;
    }
}
